export default {
  // Page title
  'layout.pass': 'Pass',
  'layout.reject': 'Reject',
};
